import { useCallback } from 'react'
import type { ModuloChecklist } from '@hooks/useChecklistGeral.js'
import { exportarJornadaProgressoPDF } from '@services/backup.js'
import { computeAlertaSequencia } from '@utils/alertaSequencia.js'
import { barFillStyle } from '@utils/barStyle.js'

interface Props {
  modulos: ModuloChecklist[]
}

function mapStatus(status: ModuloChecklist['topicos'][number]['status']) {
  if (status === 'concluido') return 'concluido' as const
  if (status === 'em-andamento') return 'em-andamento' as const
  return 'pendente' as const
}

export function JornadaProgresso({ modulos }: Props) {
  const alerta = computeAlertaSequencia(modulos)

  const handleExport = useCallback(() => {
    void exportarJornadaProgressoPDF(
      modulos.map((m) => ({
        titulo: m.titulo,
        icone: m.icone,
        pct: m.pct,
        concluidos: m.concluidos,
        total: m.total,
        topicos: m.topicos.map((t) => ({ titulo: t.titulo, status: mapStatus(t.status) })),
      })),
    )
  }, [modulos])

  return (
    <div className='cf3-progresso'>
      {alerta && (
        <div className='cf3-progresso__alerta' role='alert'>
          <p className='cf3-progresso__alerta-title'>Ordem recomendada</p>
          <p className='cf3-progresso__alerta-text'>{alerta}</p>
        </div>
      )}

      <div className='cf3-progresso__header'>
        <p className='cf3-progresso__summary'>Progresso por módulo</p>
        <button type='button' className='cf3-progresso__link' onClick={handleExport}>
          Exportar
        </button>
      </div>

      <ul className='cf3-progresso__modulos'>
        {modulos.map((m) => (
          <li key={m.id} className='cf3-progresso__modulo'>
            <div className='cf3-progresso__modulo-head'>
              <span className='cf3-progresso__modulo-name'>{m.titulo}</span>
              <span className='cf3-progresso__modulo-pct'>{m.pct}%</span>
            </div>
            <div
              className='cf3-progresso__bar'
              role='progressbar'
              aria-valuenow={m.pct}
              aria-valuemin={0}
              aria-valuemax={100}
            >
              <div className='cf3-progresso__bar-fill' style={barFillStyle(m.pct)} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
